/** @jsxImportSource @emotion/react */
import { useRef } from "react";
import Boton from "../boton";

/**
 * Elige un archivo del disco. NO lo sube: devuelve el File y quien lo use decide
 * qué hacer con él.
 *
 * Es lo que hace falta cuando el archivo no se puede subir en el momento de
 * elegirlo —por ejemplo un comprobante que se adjunta al emitir una factura,
 * cuando la factura todavía no existe—. Para subir directo a S3 en el momento
 * está SubidorArchivos, que es otra cosa.
 *
 * El input nativo va oculto: se muestra el Boton de la plataforma, que es el
 * que le da a la acción el mismo aspecto que al resto de la interfaz.
 *
 * Props:
 *   archivo     el File elegido, o null. El componente no guarda estado.
 *   onSeleccion (file) => void — recibe el File, o null al quitarlo
 *   etiqueta    texto del botón cuando no hay nada elegido
 *   accept      filtro de tipos, ej "application/pdf,image/*"
 *   disabled
 *   icono       clase del ícono (default "pi pi-paperclip")
 */
export default function SelectorArchivo({
  archivo,
  onSeleccion,
  etiqueta = "Elegir archivo",
  accept,
  disabled = false,
  icono = "pi pi-paperclip"
}) {
  const input = useRef(null);

  function alElegir(evento) {
    const elegido = evento.target.files?.[0] || null;
    // Se limpia el value para que volver a elegir el mismo archivo dispare el
    // onChange igual: si no, el navegador lo considera "sin cambios".
    evento.target.value = "";
    if (elegido) onSeleccion(elegido);
  }

  return (
    <div css={{ display: "flex", alignItems: "center", gap: "0.5em", flexWrap: "wrap" }}>
      <input
        type="file"
        ref={input}
        accept={accept}
        onChange={alElegir}
        css={{ display: "none" }}
      />

      <Boton disabled={disabled} callback={() => input.current?.click()}>
        <i className={icono} css={{ marginRight: "0.5em" }} />
        {archivo ? "Cambiar archivo" : etiqueta}
      </Boton>

      {archivo && (
        <>
          <span
            css={{
              // El nombre no tiene dónde cortar y empujaría al botón de quitar
              // fuera de la fila.
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "14em",
              color: "var(--grisTextos)"
            }}
            title={archivo.name}
          >
            {archivo.name}
          </span>
          <Boton
            texto
            icono
            chico
            negro
            disabled={disabled}
            callback={() => onSeleccion(null)}
          >
            <i className="pi pi-times" />
          </Boton>
        </>
      )}
    </div>
  );
}
